import React, { useCallback, useEffect, useState } from "react";
import { Modal } from "../../CommonUIComponents/Modal/Modal";
import "../Emissions.scss";
import { Select } from "../../CommonUIComponents/Select/Select";
import { Button } from "../..";
import {
  ApplyBtn,
  cat1,
  cat2,
  cat3,
  createNewCategory,
  createNewEntity,
  createNewRegion,
  ent1,
  ent2,
  ent3,
  ent4,
  extendScopes,
  newHierarchyWarningMessage,
  newTrgtHrchy,
  reg1,
  reg2,
  reg3,
  cust1,
  cust2,
  cust3,
  reset,
  scope,
  searchCategory,
  searchNewEntity,
  searchNewRegion,
  targetHierarchyValues,
  maxLength200,
  extendRegExp,
  commonError,
  maxCharLimitError
} from "../../../util/constants";
import { useDispatch, useSelector } from "react-redux";
import { setExtendNewHierarchy, setSelectedExtendHierarchy } from "../../../store/slices/projectSlice";
import MultiSelectCreatableOption from "../../CommonUIComponents/MultiSelectCreatableOption";

function ModalBody({ onApply, hierarchy }) {
  const [scopeSelected, setScope] = useState("");
  const [category1, setCategory1] = useState("");
  const [category2, setCategory2] = useState("");
  const [category3, setCategory3] = useState("");
  const [region1, setRegion1] = useState("");
  const [region2, setRegion2] = useState("");
  const [region3, setRegion3] = useState("");

  // Custom specifications
  const [custom1, setCustom1] = useState("");
  const [custom2, setCustom2] = useState("");
  const [custom3, setCustom3] = useState("");

  const [entitylevel1, setEntity1] = useState("");
  const [entitylevel2, setEntity2] = useState("");
  const [entitylevel3, setEntity3] = useState("");
  const [entitylevel4, setEntity4] = useState("");
  const hierarchialData = useSelector((state) => state.project.hierarchialData);
  const [category1Options, setCategory1Options] = useState([]);
  const [category2Options, setCategory2Options] = useState([]);
  const [category3Options, setCategory3Options] = useState([]);

  const [region1Options, setregion1Options] = useState([]);
  const [region2Options, setregion2Options] = useState([]);
  const [region3Options, setregion3Options] = useState([]);

  // Custom specifications options
  const [custom1Options, setCustom1Options] = useState([]);
  const [custom2Options, setCustom2Options] = useState([]);
  const [custom3Options, setCustom3Options] = useState([]);

  const [entity1Options, setEntity1Options] = useState([]);
  const [entity2Options, setEntity2Options] = useState([]);
  const [entity3Options, setEntity3Options] = useState([]);
  const [entity4Options, setEntity4Options] = useState([]);

  const [disableApply, setDisableApply] = useState(true);
  const [showError, setErrorMessage] = useState(false);
  const [validationErrorMessage, setValidationErrorMessage] = useState("");
  const [resetDisable, setResetDisable] = useState(true);
  
  const newExtendhierarchy = useSelector(
    (state) => state.project.extendNewHierarchy
  );

  const selectedUIAllFilters = useSelector(
    (state) => state?.project?.selectedUIAllFilters
  );

  const [creatablecat1, setCreatableCat1] = useState(true);
  const [creatablecat2, setCreatableCat2] = useState(true);
  const [creatablecat3, setCreatableCat3] = useState(true);
  
  const [creatablereg1, setcreatableReg1] = useState(true);
  const [creatableReg2, setcreatableReg2] = useState(true);
  const [creatableReg3, setcreatableReg3] = useState(true);

  // Custom specifications creatable states
  const [creatablecus1, setcreatablecus1] = useState(true);
  const [creatablecus2, setcreatablecus2] = useState(true);
  const [creatablecus3, setcreatablecus3] = useState(true);

  const [creatableEntity1, setcreatableEntity1] = useState(true);
  const [creatableEntity2, setcreatableEntity2] = useState(true);
  const [creatableEntity3, setcreatableEntity3] = useState(true);
  const [creatableEntity4, setcreatableEntity4] = useState(true);
  const [resetOptions, setReset] = useState(false);
  const [disableAll, setDisableAll] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    let data = [...hierarchialData];
    if (hierarchy === targetHierarchyValues[1]) {
      let array = [...new Set(data.map((element) => element["region_level1"]))];
      let options = [];
      array.forEach((value) => {
        options.push({ label: value, value: value, disabled: false });
      });
      setregion1Options(options);
      if (newExtendhierarchy.saved) {
        if(newExtendhierarchy?.region1?.label
          && newExtendhierarchy?.region2?.label
          && newExtendhierarchy?.region3?.label) 
         { 
          setDisableAll(true);
          setRegion1(newExtendhierarchy?.region1);
          setRegion2(newExtendhierarchy?.region2);
          setRegion3(newExtendhierarchy?.region3);
        }  
      }
    } else if (hierarchy === targetHierarchyValues[2]) {
      let array = [...new Set(data.map((element) => element["entity_level1"]))];
      let options = [];
      array.forEach((value) => {
        options.push({ label: value, value: value, disabled: false });
      });
      setEntity1Options(options);
      if (newExtendhierarchy.saved) {
        
        if(newExtendhierarchy?.entity1?.label 
          && newExtendhierarchy?.entity2?.label 
          && newExtendhierarchy?.entity3?.label 
          && newExtendhierarchy?.entity4?.label) setDisableAll(true);

        setEntity1(newExtendhierarchy?.entity1);
        setEntity2(newExtendhierarchy?.entity2);
        setEntity3(newExtendhierarchy?.entity3);
        setEntity4(newExtendhierarchy?.entity4);
      }
    } else if (hierarchy === targetHierarchyValues[3]) {
      let array = [...new Set(data.map((element) => element["custom_specification1"]))];
      let options = [];
      array.forEach((value) => {
        if(value !== '') options.push({ label: value, value: value, disabled: false });
      });
      setCustom1Options(options);
      if (newExtendhierarchy.saved) {
        
        if(newExtendhierarchy?.custom1?.label) setDisableAll(true);

        setCustom1(newExtendhierarchy?.custom1);
        setCustom2(newExtendhierarchy?.custom2);
        setCustom3(newExtendhierarchy?.custom3);
      }
    }
    if (newExtendhierarchy.saved) {
      if (hierarchy === targetHierarchyValues[0]) {
        if(newExtendhierarchy?.scope?.label 
          && newExtendhierarchy?.category1?.label 
          && newExtendhierarchy?.category2?.label 
          && newExtendhierarchy?.category3?.label) setDisableAll(true);

        setScope(newExtendhierarchy?.scope?.value);
        handleOnChange(newExtendhierarchy?.scope?.value, "scope");
        setCategory1(newExtendhierarchy?.category1);
        setCategory2(newExtendhierarchy?.category2);
        setCategory3(newExtendhierarchy?.category3);
      }
    }
    setDisableApply(true);
  }, [hierarchy]);

  const isValidValue = (val) => {
    if (!val) return false;
    if (typeof val === "object" && !Array.isArray(val)) {
      return !!val.label;
    }
    return true; // string / number
  };

  // Validation functions
  const hasLengthError = (value) => {
    if (!value) return false;
    const trimmedValue = typeof value === 'string' ? value.trim() : value;
    return trimmedValue.length > 200;
  };

  const hasPatternError = (value) => {
    if (!value) return false;
    const trimmedValue = typeof value === 'string' ? value.trim() : value;
    if (trimmedValue.length > 200) return false; // Don't check pattern if already over length limit
    return !extendRegExp.test(trimmedValue);
  };

  // Helper function to extract string value from field (handles both string and object types)
  const getStringValue = (value) => {
    if (!value) return "";
    if (typeof value === "string") return value;
    if (typeof value === "object" && !Array.isArray(value)) {
      return value.label || value.value || "";
    }
    return "";
  };

  // Helper function to get all values that need validation
  const getValuesToValidate = () => {
    const values = [];
    
    if (hierarchy === "Emission") {
      values.push(category1, category2, category3);
    } else if (hierarchy === "Geography") {
      values.push(region1, region2, region3);
    } else if (hierarchy === "Organisational") {
      values.push(entitylevel1, entitylevel2, entitylevel3, entitylevel4);
    } else if (hierarchy === "Custom") {
      values.push(custom1, custom2, custom3);
    }
    
    // Extract string values and filter out empty ones
    return values
      .map(val => getStringValue(val))
      .filter(val => val !== "");
  };

  // Check which specific validation error exists (used by both useEffect and saveValues)
  const getValidationErrorType = () => {
    const valuesToCheck = getValuesToValidate();
    
    if (valuesToCheck.length === 0) return null;
    
    const hasLengthErr = valuesToCheck.some(val => hasLengthError(val));
    if (hasLengthErr) return 'length';
    
    const hasPatternErr = valuesToCheck.some(val => hasPatternError(val));
    if (hasPatternErr) return 'pattern';
    
    return null;
  };

  useEffect(() => {
    let invalid = true;
    const isObject = (value) => value !== null && typeof value === "object" && !Array.isArray(value);
    
    if (hierarchy === "Emission") {
      if (category1 && category2 && category3) {
        if(isObject(category1) || isObject(category2) || isObject(category3)) {
          if(category1?.label && category2?.label && category3?.label) {
            invalid = false;
          }
        } else {
          invalid = false;
        }
      }
    }

    if (hierarchy === "Geography") {
      if (region1 && region2 && region3) {
        if(isObject(region1) || isObject(region2) || isObject(region3)) {
          if(region1?.label && region2?.label && region3?.label) {
            invalid = false;
          }
        } else {
          invalid = false;
        }
      }
    }

    if (hierarchy === "Organisational") {
      if (entitylevel1 && entitylevel2 && entitylevel3 && entitylevel4) {
        if(isObject(entitylevel1) || isObject(entitylevel2) || isObject(entitylevel3) || isObject(entitylevel4)) {
          if(entitylevel1?.label && entitylevel2?.label && entitylevel3?.label && entitylevel4?.label) {
            invalid = false;
          }
        } else {
          invalid = false;
        }
      }
    }

    if (hierarchy === "Custom") {
      // custom1 is mandatory
      if (!isValidValue(custom1)) {
        invalid = true;
      }
      // custom3 cannot exist without custom2
      else if (!isValidValue(custom2) && isValidValue(custom3)) {
        invalid = true;
      }
      // valid cases
      else {
        invalid = false;
      }
    }
    
    // Check for validation errors (length/pattern)
    const errorType = getValidationErrorType();
    const hasErrors = errorType !== null;
    
    // Disable Apply if fields are incomplete OR validation errors exist
    setDisableApply(invalid || hasErrors);
    
    // Show appropriate validation error message in real-time based on error type
    if (errorType === 'length') {
      setValidationErrorMessage(maxCharLimitError);
    } else if (errorType === 'pattern') {
      setValidationErrorMessage(commonError);
    } else if (validationErrorMessage) {
      // Clear validation error message when no errors exist
      setValidationErrorMessage("");
    }
  }, [
    category1,
    category2,
    category3,
    hierarchy,
    region1,
    region2,
    region3,
    entitylevel1,
    entitylevel2,
    entitylevel3,
    entitylevel4,
    custom1,
    custom2,
    custom3,
    validationErrorMessage
  ]);
    

  useEffect(() => {
    if (scopeSelected !== "" || region1 !== "" || entitylevel1 !== "" || custom1 !== "") {
      setResetDisable(false);
    } else {
      setResetDisable(true);
    }
  }, [scopeSelected, region1, entitylevel1, custom1]);

  const resetCategoriesFrom = (level) => {
    if (level <= 1) {
      setCategory1("");
      setCategory1Options([]);
    }
    if (level <= 2) {
      setCategory2("");
      setCategory2Options([]);
    }
    if (level <= 3) {
      setCategory3("");
      setCategory3Options([]);
    }
  };

  const resetRegionsFrom = (level) => {
    if (level <= 2) {
      setRegion2("");
      setregion2Options([]);
    }
    if (level <= 3) {
      setRegion3("");
      setregion3Options([]);
    }
  };

  const resetCustomsFrom = (level) => {
    if (level <= 2) {
      setCustom2("");
      setCustom2Options([]);
    }
    if (level <= 3) {
      setCustom3("");
      setCustom3Options([]);
    }
  };

  const resetEntitiesFrom = (level) => {
    if (level <= 2) {
      setEntity2("");
      setEntity2Options([]);
    }
    if (level <= 3) {
      setEntity3("");
      setEntity3Options([]);
    }
    if (level <= 4) {
      setEntity4("");
      setEntity4Options([]);
    }
  };

  // onChange function
  const handleOnChange = useCallback(async (value, field) => {
    let data = [...hierarchialData];
    let array = [];
    let options = [];
    let disabledOptions = [];
    let a = [];
    setErrorMessage(false);
    setValidationErrorMessage("");
    switch (field) {
      case "scope":
        resetCategoriesFrom(1);
        setScope(value);
        data = data.filter((element) => element.scope === value);
        array = [...new Set(data.map((element) => element["category_level1"]))];
        array.forEach((element) => {
          options.push({ label: element, value: element, disabled: false });
        });
        setCategory1Options(options);
        break;
      case "Category 1":
        resetCategoriesFrom(2);
        setCategory1(value.length > 0 ? value[0].value : value);
        value.length > 0 ? setCreatableCat1(false) : setCreatableCat1(true);
        data = data.filter(
          (element) =>
            element.scope === scopeSelected &&
            element.category_level1 === value[0]?.value
        );
        array = [...new Set(data.map((element) => element["category_level2"]))];
        array.forEach((element) => {
          options.push({ label: element, value: element, disabled: false });
        });
        setCategory2Options(options);
        category1Options.forEach((element) => {
          if (element.value === value[0]?.value || value[0] === undefined) {
            disabledOptions.push({
              label: element.label,
              value: element.value,
              disabled: false,
            });
          } else if (element.value !== undefined) {
            disabledOptions.push({
              label: element.label,
              value: element.value,
              disabled: true,
            });
          }
        });
        if (value.length > 0 && value[0] !== "") {
          a = [...new Set(disabledOptions.map((element) => element["value"]))];
          if (!a.includes(value[0]?.value)) {
            disabledOptions.push({
              label: value[0]?.value,
              value: value[0]?.value,
              disabled: false,
            });
            setCreatableCat1(false);
          }
        } else {
          setCreatableCat1(true);
        }
        setCategory1Options(disabledOptions);
        break;
      case "Category 2":
        resetCategoriesFrom(3);
        setCategory2(value[0]?.value);
        value.length > 0 ? setCreatableCat2(false) : setCreatableCat2(true);
        data = data.filter(
          (element) =>
            element.scope === scopeSelected &&
            element.category_level2 === value[0]?.value
        );
        array = [...new Set(data.map((element) => element["category_level3"]))];
        array.forEach((element) => {
          options.push({ label: element, value: element, disabled: false });
        });
        setCategory3Options(options);
        category2Options.forEach((element) => {
          if (element.value === value[0]?.value || value[0] === undefined) {
            disabledOptions.push({
              label: element.label,
              value: element.value,
              disabled: false,
            });
          } else if (element.value !== undefined) {
            disabledOptions.push({
              label: element.label,
              value: element.value,
              disabled: true,
            });
          }
        });
        if (value.length > 0 && value[0] !== "") {
          a = [...new Set(disabledOptions.map((element) => element["value"]))];
          if (!a.includes(value[0]?.value)) {
            disabledOptions.push({
              label: value[0]?.value,
              value: value[0]?.value,
              disabled: false,
            });
            setCreatableCat2(false);
          }
        } else {
          setCreatableCat2(true);
        }
        setCategory2Options(disabledOptions);
        break;
      case "Category 3":
        setCategory3(value[0]?.value);
        value.length > 0 ? setCreatableCat3(false) : setCreatableCat3(true);
        category3Options.forEach((element) => {
          if (element.value === value[0]?.value || value[0] === undefined) {
            disabledOptions.push({
              label: element.label,
              value: element.value,
              disabled: false,
            });
          } else if (element.value !== undefined) {
            disabledOptions.push({
              label: element.label,
              value: element.value,
              disabled: true,
            });
          }
        });
        if (value.length > 0 && value[0] !== "") {
          a = [...new Set(disabledOptions.map((element) => element["value"]))];
          if (!a.includes(value[0]?.value)) {
            disabledOptions.push({
              label: value[0]?.value,
              value: value[0]?.value,
              disabled: false,
            });
            setCreatableCat3(false);
          }
        }
        setCategory3Options(disabledOptions);
        break;
      case "Region 1":
        resetRegionsFrom(2);
        setRegion1(value[0]?.value);
        if (value.length > 0) {
          setcreatableReg1(false);
        } else {
          setcreatableReg1(true);
        }
        const allValues1 = region1Options.map(opt => opt?.value);
        if(allValues1.includes(value[0]?.value)) {
          data = data.filter(
            (element) => element.region_level1 === value[0]?.value
          );
          array = [...new Set(data.map((element) => element["region_level2"]))];
          array.forEach((element) => {
            options.push({ label: element, value: element, disabled: false });
          });
          setregion2Options(options);
        }  
        region1Options.forEach((element) => {
          if (element.value === value[0]?.value || value[0] === undefined) {
            disabledOptions.push({
              label: element.label,
              value: element.value,
              disabled: false,
            });
          } else if (element.value !== undefined) {
            disabledOptions.push({
              label: element.label,
              value: element.value,
              disabled: true,
            });
          }
        });
        if (value.length > 0 && value[0] !== "") {
          a = [...new Set(disabledOptions.map((element) => element["value"]))];
          if (!a.includes(value[0]?.value)) {
            disabledOptions.push({
              label: value[0]?.value,
              value: value[0]?.value,
              disabled: false,
            });
            setcreatableReg1(false);
          }
        }
        setregion1Options(disabledOptions);
        break;
      case "Region 2":
        resetRegionsFrom(3);
        setRegion2(value[0]?.value);
        if (value.length > 0) {
          setcreatableReg2(false);
        } else {
          setcreatableReg2(true);
        }
        const allValues = region2Options.map(opt => opt?.value);
        if(allValues.includes(value[0]?.value)) {
          data = data.filter(
            (element) => element.region_level2 === value[0]?.value
          );
          array = [...new Set(data.map((element) => element["region_level3"]))];
          array.forEach((element) => {
            options.push({ label: element, value: element, disabled: false });
          });
          setregion3Options(options);
        }
        region2Options.forEach((element) => {
          if (element.value === value[0]?.value || value[0] === undefined) {
            disabledOptions.push({
              label: element.label,
              value: element.value,
              disabled: false,
            });
          } else if (element.value !== undefined) {
            disabledOptions.push({
              label: element.label,
              value: element.value,
              disabled: true,
            });
          }
        });
        if (value.length > 0 && value[0] !== "") {
          a = [...new Set(disabledOptions.map((element) => element["value"]))];
          if (!a.includes(value[0]?.value)) {
            disabledOptions.push({
              label: value[0]?.value,
              value: value[0]?.value,
              disabled: false,
            });
            setcreatableReg2(false);
          }
        }
        setregion2Options(disabledOptions);
        break;
      case "Region 3":
        setRegion3(value[0]?.value);
        if (value.length > 0) {
          setcreatableReg3(false);
        } else {
          setcreatableReg3(true);
        }
        region3Options.forEach((element) => {
          if (element.value === value[0]?.value || value[0] === undefined) {
            disabledOptions.push({
              label: element.label,
              value: element.value,
              disabled: false,
            });
          } else if (element.value !== undefined) {
            disabledOptions.push({
              label: element.label,
              value: element.value,
              disabled: true,
            });
          }
        });
        if (value.length > 0 && value[0] !== "") {
          a = [...new Set(disabledOptions.map((element) => element["value"]))];
          if (!a.includes(value[0]?.value)) {
            disabledOptions.push({
              label: value[0]?.value,
              value: value[0]?.value,
              disabled: false,
            });
            setcreatableReg3(false);
          }
        }
        setregion3Options(disabledOptions);
        break;
      // Custom specifications
      case "Custom 1":
        resetCustomsFrom(2);
        setCustom1(value[0]?.value);
        if (value.length > 0) {
          setcreatablecus1(false);
        } else {
          setcreatablecus1(true);
        }
        const allValuesCus1 = custom1Options.map(opt => opt?.value);
        if(allValuesCus1.includes(value[0]?.value)) {
          data = data.filter(
            (element) => element.custom_specification1 === value[0]?.value
          );
          array = [...new Set(data.map((element) => element["custom_specification2"]))];
          array.forEach((element) => {
            options.push({ label: element, value: element, disabled: false });
          });
          setCustom2Options(options);
        }  
        custom1Options.forEach((element) => {
          if (element.value === value[0]?.value || value[0] === undefined) {
            if(element.label !== '') {
              disabledOptions.push({
                label: element.label,
                value: element.value,
                disabled: false,
              });
            }
          } else if (element.value !== undefined) {
            if(element.label !== '') {
              disabledOptions.push({
                label: element.label,
                value: element.value,
                disabled: true,
              });
            }
          }
        });
        if (value.length > 0 && value[0] !== "") {
          a = [...new Set(disabledOptions.map((element) => element["value"]))];
          if (!a.includes(value[0]?.value)) {
              if(value[0]?.value !== "") {
                disabledOptions.push({
                label: value[0]?.value,
                value: value[0]?.value,
                disabled: false,
              });
              setcreatablecus1(false);
            }
          }
        }
        setCustom1Options(disabledOptions);
        break;
      case "Custom 2":
        resetCustomsFrom(3);
        setCustom2(value[0]?.value);
        if (value.length > 0) {
          setcreatablecus2(false);
        } else {
          setcreatablecus2(true);
        }
        const allValuesCus2 = custom2Options.map(opt => opt?.value);
        if(allValuesCus2.includes(value[0]?.value)) {
          data = data.filter(
            (element) => element.custom_specification2 === value[0]?.value
          );
          array = [...new Set(data.map((element) => element["custom_specification3"]))];
          array.forEach((element) => {
            options.push({ label: element, value: element, disabled: false });
          });
          setCustom3Options(options);
        }
        custom2Options.forEach((element) => {
          if (element.value === value[0]?.value || value[0] === undefined) {
            if(element.label !== '') {
              disabledOptions.push({
                label: element.label,
                value: element.value,
                disabled: false,
              });
            }
          } else if (element.value !== undefined) {
            if(element.label !== '') {
              disabledOptions.push({
                label: element.label,
                value: element.value,
                disabled: true,
              });
            }
          }
        });
        if (value.length > 0 && value[0] !== "") {
          a = [...new Set(disabledOptions.map((element) => element["value"]))];
          if (!a.includes(value[0]?.value)) {
            if(value[0]?.value !== "") {
              disabledOptions.push({
                label: value[0]?.value,
                value: value[0]?.value,
                disabled: false,
              });
              setcreatablecus2(false);
            }
          }
        }
        setCustom2Options(disabledOptions);
        break;
      case "Custom 3":
        setCustom3(value[0]?.value);
        if (value.length > 0) {
          setcreatablecus3(false);
        } else {
          setcreatablecus3(true);
        }
        custom3Options.forEach((element) => {
          if (element.value === value[0]?.value || value[0] === undefined) {
            if(element.label !== '') {
              disabledOptions.push({
                label: element.label,
                value: element.value,
                disabled: false,
              });
            }
          } else if (element.value !== undefined) {
            if(element.label !== '') {
              disabledOptions.push({
                label: element.label,
                value: element.value,
                disabled: true,
              });
            }
          }
        });
        if (value.length > 0 && value[0] !== "") {
          a = [...new Set(disabledOptions.map((element) => element["value"]))];
          if (!a.includes(value[0]?.value)) {
            if(value[0]?.value !== "") {
              disabledOptions.push({
                label: value[0]?.value,
                value: value[0]?.value,
                disabled: false,
              });
              setcreatablecus3(false);
            }
          }
        }
        setCustom3Options(disabledOptions);
        break;
      case "Entity 1":
        resetEntitiesFrom(2);
        setEntity1(value[0]?.value);
        value.length > 0
          ? setcreatableEntity1(false)
          : setcreatableEntity1(true);

        const allValuesEnt1 = entity1Options.map(opt => opt?.value);
        if(allValuesEnt1.includes(value[0]?.value)) {  
          data = data.filter(
            (element) => element.entity_level1 === value[0]?.value
          );
          array = [...new Set(data.map((element) => element["entity_level2"]))];
          array.forEach((element) => {
            options.push({ label: element, value: element, disabled: false });
          });
          setEntity2Options(options);
        } 
        entity1Options.forEach((element) => {
          if (element.value === value[0]?.value || value[0] === undefined) {
            disabledOptions.push({
              label: element.label,
              value: element.value,
              disabled: false,
            });
          } else if (element.value !== undefined) {
            disabledOptions.push({
              label: element.label,
              value: element.value,
              disabled: true,
            });
          }
        });
        if (value.length > 0 && value[0] !== "") {
          a = [...new Set(disabledOptions.map((element) => element["value"]))];
          if (!a.includes(value[0]?.value)) {
            disabledOptions.push({
              label: value[0]?.value,
              value: value[0]?.value,
              disabled: false,
            });
            setcreatableEntity1(false);
          }
        }
        setEntity1Options(disabledOptions);
        break;
      case "Entity 2":
        resetEntitiesFrom(3);
        setEntity2(value[0]?.value);
        value.length > 0
          ? setcreatableEntity2(false)
          : setcreatableEntity2(true);

        const allValuesEnt2 = entity2Options.map(opt => opt?.value);
        if(allValuesEnt2.includes(value[0]?.value)) {    
          data = data.filter(
            (element) => element.entity_level2 === value[0]?.value
          );
          array = [...new Set(data.map((element) => element["entity_level3"]))];
          array.forEach((element) => {
            options.push({ label: element, value: element, disabled: false });
          });
          setEntity3Options(options);
        }
        entity2Options.forEach((element) => {
          if (element.value === value[0]?.value || value[0] === undefined) {
            disabledOptions.push({
              label: element.label,
              value: element.value,
              disabled: false,
            });
          } else if (element.value !== undefined) {
            disabledOptions.push({
              label: element.label,
              value: element.value,
              disabled: true,
            });
          }
        });
        if (value.length > 0 && value[0] !== "") {
          a = [...new Set(disabledOptions.map((element) => element["value"]))];
          if (!a.includes(value[0]?.value)) {
            disabledOptions.push({
              label: value[0]?.value,
              value: value[0]?.value,
              disabled: false,
            });
            setcreatableEntity2(false);
          }
        }
        setEntity2Options(disabledOptions);
        break;
      case "Entity 3":
        resetEntitiesFrom(4);
        setEntity3(value[0]?.value);
        value.length > 0
          ? setcreatableEntity3(false)
          : setcreatableEntity3(true);

        const allValuesEnt3 = entity3Options.map(opt => opt?.value);
        if(allValuesEnt3.includes(value[0]?.value)) {  
          data = data.filter(
            (element) => element.entity_level3 === value[0]?.value
          );
          array = [...new Set(data.map((element) => element["entity_level4"]))];
          array.forEach((element) => {
            options.push({ label: element, value: element, disabled: false });
          });
          setEntity4Options(options);
        }
        entity3Options.forEach((element) => {
          if (element.value === value[0]?.value || value[0] === undefined) {
            disabledOptions.push({
              label: element.label,
              value: element.value,
              disabled: false,
            });
          } else if (element.value !== undefined) {
            disabledOptions.push({
              label: element.label,
              value: element.value,
              disabled: true,
            });
          }
        });
        if (value.length > 0 && value[0] !== "") {
          a = [...new Set(disabledOptions.map((element) => element["value"]))];
          if (!a.includes(value[0]?.value)) {
            disabledOptions.push({
              label: value[0]?.value,
              value: value[0]?.value,
              disabled: false,
            });
            setcreatableEntity3(false);
          }
        }
        setEntity3Options(disabledOptions);
        break;
      case "Entity 4":
        setEntity4(value[0]?.value);
        value.length > 0
          ? setcreatableEntity4(false)
          : setcreatableEntity4(true);
        entity4Options.forEach((element) => {
          if (element.value === value[0]?.value || value[0] === undefined) {
            disabledOptions.push({
              label: element.label,
              value: element.value,
              disabled: false,
            });
          } else if (element.value !== undefined) {
            disabledOptions.push({
              label: element.label,
              value: element.value,
              disabled: true,
            });
          }
        });
        if (value.length > 0 && value[0] !== "") {
          a = [...new Set(disabledOptions.map((element) => element["value"]))];
          if (!a.includes(value[0]?.value)) {
            disabledOptions.push({
              label: value[0]?.value,
              value: value[0]?.value,
              disabled: false,
            });
            setcreatableEntity4(false);
          }
        }
        setEntity4Options(disabledOptions);
        break;
      default:
        break;
    }
  }, [
    extendScopes,
    category1Options,
    category2Options,
    category3Options,
    region1Options,
    region2Options,
    region3Options,
    entity1Options,
    entity2Options,
    entity3Options,
    entity4Options,
    hierarchy,
    hierarchialData,
    custom1Options,
    custom2Options,
    custom3Options
  ]);

 const saveValues = () => {
  const scopesData = selectedUIAllFilters?.scope || [];
  const categories1Data = selectedUIAllFilters?.category_level1 || [];
  const categories2Data = selectedUIAllFilters?.category_level2 || [];
  const categories3Data = selectedUIAllFilters?.category_level3 || [];
  const regions1Data = selectedUIAllFilters?.region_level1 || [];
  const regions2Data = selectedUIAllFilters?.region_level2 || [];
  const regions3Data = selectedUIAllFilters?.region_level3 || [];
  const entities1Data = selectedUIAllFilters?.entity_level1 || [];
  const entities2Data = selectedUIAllFilters?.entity_level2 || [];
  const entities3Data = selectedUIAllFilters?.entity_level3 || [];
  const entities4Data = selectedUIAllFilters?.entity_level4 || [];

  // 1️⃣ Filter by selected scopes
  const filteredData = (hierarchialData.filter(item =>
    scopesData.includes(item.scope)
  )).filter(item => 
      categories1Data?.includes(item.category_level1)
  ).filter(item =>
      categories2Data?.includes(item.category_level2)
  ).filter(item =>
      categories3Data?.includes(item.category_level3)
  ).filter(item =>
      regions1Data?.includes(item.region_level1)
  ).filter(item =>
      regions2Data?.includes(item.region_level2)
  ).filter(item =>
      regions3Data?.includes(item.region_level3)
  ).filter(item =>
      entities1Data?.includes(item.entity_level1)
  ).filter(item =>
      entities2Data?.includes(item.entity_level2)
  ).filter(item =>
      entities3Data?.includes(item.entity_level3)
  ).filter(item =>
      entities4Data?.includes(item.entity_level4)
  )

  console.log("filteredData", filteredData);

  // 2️⃣ Decide what fields to override based on hierarchy
  const overridesByHierarchy = {
    Emission: {
      scope: scopeSelected,
      category_level1: category1,
      category_level2: category2,
      category_level3: category3
    },
    Geography: {
      region_level1: region1,
      region_level2: region2,
      region_level3: region3
    },
    Organisational: {
      entity_level1: entitylevel1,
      entity_level2: entitylevel2,
      entity_level3: entitylevel3,
      entity_level4: entitylevel4
    },
    Custom: {
      custom_specification1: custom1,
      custom_specification2: custom2,
      custom_specification3: custom3
    }
  };

  // 3️⃣ Build new hierarchy
  const newTargetHierarchy = filteredData.map(item => ({
    ...item,
    ...(overridesByHierarchy[hierarchy] || {})
  }));

  // 4️⃣ Build key generator
  const buildKey = obj =>
    [
      obj.engagementCode,
      obj.region_level1,
      obj.region_level2,
      obj.region_level3,
      obj.entity_level1,
      obj.entity_level2,
      obj.entity_level3,
      obj.entity_level4,
      obj.scope,
      obj.category_level1,
      obj.category_level2,
      obj.category_level3,
      obj.custom_specification1,
      obj.custom_specification2,
      obj.custom_specification3
    ].join("|");

  // 5️⃣ Detect if ANY combination already exists
  const existingSet = new Set(hierarchialData.map(buildKey));

  const isAnyCombinationRepeated = newTargetHierarchy.some(item =>
    existingSet.has(buildKey(item))
  );

  const results = newTargetHierarchy.map(item => ({
    ...item,
    alreadyExists: existingSet.has(buildKey(item))
  }));
  
  console.log("isAnyCombinationRepeated", isAnyCombinationRepeated);
  console.log("results", results);

  // Use helper function to get values and check error type (DRY principle)
  const errorType = getValidationErrorType();
  const hasInvalidValue = errorType !== null;
  
  if(!isAnyCombinationRepeated && !hasInvalidValue) {
    let obj = {
      scope: { label: scopeSelected, value: scopeSelected },
      category1: { label: category1, value: category1 },
      category2: { label: category2, value: category2 },
      category3: { label: category3, value: category3 },
      region1: { label: region1, value: region1 },
      region2: { label: region2, value: region2 },
      region3: { label: region3, value: region3 },
      entity1: { label: entitylevel1, value: entitylevel1 },
      entity2: { label: entitylevel2, value: entitylevel2 },
      entity3: { label: entitylevel3, value: entitylevel3 },
      entity4: { label: entitylevel4, value: entitylevel4 },
      custom1: { label: custom1 ? custom1 : '', value: custom1 ? custom1 : '' },
      custom2: { label: custom2 ? custom2 : '', value: custom2 ? custom2 : '' },
      custom3: { label: custom3 ? custom3 : '', value: custom3 ? custom3 : '' },
      saved: true,
    };
    dispatch(setExtendNewHierarchy({ rule: obj }));
    dispatch(setSelectedExtendHierarchy(hierarchy));
    setValidationErrorMessage("");
    onApply();
  } else {
    if(hasInvalidValue) {
      // Show specific error message based on error type (priority: length > pattern)
      if (errorType === 'length') {
        setValidationErrorMessage(maxCharLimitError);
      } else if (errorType === 'pattern') {
        setValidationErrorMessage(commonError);
      }
    } else {
      setValidationErrorMessage("")
      setErrorMessage(true);
    }
    setDisableApply(true); 
  }
};

  const resetFields = () => {
    setReset(true);
    setScope([]);
    setCategory1([]);
    setCategory1Options([]);
    setCategory2Options([]);
    setCategory3Options([]);
    setCategory2([]);
    setCategory3([]);
    setRegion1([]);
    setRegion2([]);
    setRegion3([]);
    setEntity1([]);
    setEntity2([]);
    setEntity3([]);
    setEntity4([]);
    setCustom1([]);
    setCustom2([]);
    setCustom3([]);
    setDisableApply(true);
    dispatch(setExtendNewHierarchy({ rule: {} }));
    dispatch(setSelectedExtendHierarchy(''));
    setDisableAll(false);
    setErrorMessage(false);
    setValidationErrorMessage("")
  };

  useEffect(() => {
    setTimeout(() => {
      setReset(false);
    }, 1000);
  }, [resetOptions]);

  return (
    <div className="extend-modal">
      {hierarchy === "Emission" && (
        <div className="extend-row">
          <div className="extend-row-input">
            <span>
              {scope}
              <span className="required-star">*</span>
            </span>
            <Select
              options={extendScopes}
              onChange={(event) => {
                handleOnChange(event, "scope");
              }}
              className={disableAll ? "disable-select-scope" : ""}
              value={scopeSelected}
              multiple={false}
              disabled={disableAll}
            ></Select>
          </div>
          <div className="extend-row-input">
            <span>
              {cat1}
              <span className="required-star">*</span>
            </span>

            <MultiSelectCreatableOption
              value={category1}
              onChange={(e) => {
                handleOnChange(e, "Category 1");
              }}
              id="base-year-scope-1-2"
              avilableOptions={category1Options}
              // label={cat1}
              overrideStrings={{
                create: createNewCategory,
                search: searchCategory,
              }}
              hasSelectAll={false}
              disabled={scopeSelected === "" || disableAll}
              isCreatable={creatablecat1}
              reset={resetOptions}
            ></MultiSelectCreatableOption>
          </div>
          <div className="extend-row-input">
            <span>
              {cat2}
              <span className="required-star">*</span>  
            </span>
            <MultiSelectCreatableOption
              value={category2}
              onChange={(e) => {
                handleOnChange(e, "Category 2");
              }}
              id="base-year-scope-1-2"
              avilableOptions={category2Options}
              // label={cat2}
              overrideStrings={{
                create: createNewCategory,
                search: searchCategory,
              }}
              hasSelectAll={false}
              disabled={category1 === "" || disableAll}
              isCreatable={creatablecat2}
              reset={resetOptions}
            ></MultiSelectCreatableOption>
          </div>
          <div className="extend-row-input">
            <span>
              {cat3}
              <span className="required-star">*</span>
            </span>
            <MultiSelectCreatableOption
              value={category3}
              onChange={(e) => {
                handleOnChange(e, "Category 3");
              }}
              id="base-year-scope-1-2"
              avilableOptions={category3Options}
              // label={cat3}
              overrideStrings={{
                create: createNewCategory,
                search: searchCategory,
              }}
              hasSelectAll={false}
              disabled={category2 === "" || disableAll}
              isCreatable={creatablecat3}
              reset={resetOptions}
            ></MultiSelectCreatableOption>
          </div>
        </div>
      )}
      {hierarchy === "Geography" && (
        <div className="extend-row">
          <div className="extend-row-input">
            <span>
              {reg1}
              <span className="required-star">*</span>
            </span>
            <MultiSelectCreatableOption
              value={region1}
              onChange={(e) => {
                handleOnChange(e, "Region 1");
              }}
              id="base-year-scope-1-2"
              avilableOptions={region1Options}
              // label={reg1}
              overrideStrings={{
                create: createNewRegion,
                search: searchNewRegion,
              }}
              hasSelectAll={false}
              isCreatable={creatablereg1}
              reset={resetOptions}
              disabled={disableAll}
            ></MultiSelectCreatableOption>
          </div>
          <div className="extend-row-input">
            <span>
              {reg2}
              <span className="required-star">*</span>
            </span>
            <MultiSelectCreatableOption
              value={region2}
              onChange={(e) => {
                handleOnChange(e, "Region 2");
              }}
              id="base-year-scope-1-2"
              avilableOptions={region2Options}
              // label={reg2}
              overrideStrings={{
                create: createNewRegion,
                search: searchNewRegion,
              }}
              hasSelectAll={false}
              disabled={region1 === "" || disableAll}
              isCreatable={creatableReg2}
              reset={resetOptions}
            ></MultiSelectCreatableOption>
          </div>
          <div className="extend-row-input">
            <span>
              {reg3}
              <span className="required-star">*</span>
            </span>
            <MultiSelectCreatableOption
              value={region3}
              onChange={(e) => {
                handleOnChange(e, "Region 3");
              }}
              id="base-year-scope-1-2"
              avilableOptions={region3Options}
              // label={reg3}
              overrideStrings={{
                create: createNewRegion,
                search: searchNewRegion,
              }}
              hasSelectAll={false}
              disabled={region2 === "" || disableAll}
              isCreatable={creatableReg3}
              reset={resetOptions}
            ></MultiSelectCreatableOption>
          </div>
        </div>
      )}
      {hierarchy === "Custom" && (
        <div className="extend-row">
          <div className="extend-row-input">
            <span>
              {cust1}
              <span className="required-star">*</span>
            </span>
            <MultiSelectCreatableOption
              value={custom1}
              onChange={(e) => {
                handleOnChange(e, "Custom 1");
              }}
              id="base-year-scope-1-2"
              avilableOptions={custom1Options}
              // label={reg1}
              overrideStrings={{
                create: createNewRegion,
                search: searchNewRegion,
              }}
              hasSelectAll={false}
              isCreatable={creatablecus1}
              reset={resetOptions}
              disabled={disableAll}
            ></MultiSelectCreatableOption>
          </div>
          <div className="extend-row-input">
            <span>
              {cust2}
              {/* <span className="required-star">*</span> */}
            </span>
            <MultiSelectCreatableOption
              value={custom2}
              onChange={(e) => {
                handleOnChange(e, "Custom 2");
              }}
              id="base-year-scope-1-2"
              avilableOptions={custom2Options}
              // label={reg2}
              overrideStrings={{
                create: createNewRegion,
                search: searchNewRegion,
              }}
              hasSelectAll={false}
              disabled={custom1 === "" || disableAll}
              isCreatable={creatablecus2}
              reset={resetOptions}
            ></MultiSelectCreatableOption>
          </div>
          <div className="extend-row-input">
            <span>
              {cust3}
              {/* <span className="required-star">*</span> */}
            </span>
            <MultiSelectCreatableOption
              value={custom3}
              onChange={(e) => {
                handleOnChange(e, "Custom 3");
              }}
              id="base-year-scope-1-2"
              avilableOptions={custom3Options}
              // label={reg3}
              overrideStrings={{
                create: createNewRegion,
                search: searchNewRegion,
              }}
              hasSelectAll={false}
              disabled={custom2 === "" || disableAll}
              isCreatable={creatablecus3}
              reset={resetOptions}
            ></MultiSelectCreatableOption>
          </div>
        </div>
      )}
      {hierarchy === "Organisational" && (
        <div className="extend-row">
          <div className="extend-row-input">
            <span>
              {ent1}
              <span className="required-star">*</span>
            </span>
            <MultiSelectCreatableOption
              value={entitylevel1}
              onChange={(e) => {
                handleOnChange(e, "Entity 1");
              }}
              id="base-year-scope-1-2"
              avilableOptions={entity1Options}
              // label={ent1}
              overrideStrings={{
                create: createNewEntity,
                search: searchNewEntity,
              }}
              hasSelectAll={false}
              isCreatable={creatableEntity1}
              reset={resetOptions}
              disabled={disableAll}
            ></MultiSelectCreatableOption>
          </div>
          <div className="extend-row-input">
            <span>
              {ent2}
              <span className="required-star">*</span>
            </span>
            <MultiSelectCreatableOption
              value={entitylevel2}
              onChange={(e) => {
                handleOnChange(e, "Entity 2");
              }}
              id="base-year-scope-1-2"
              avilableOptions={entity2Options}
              // label={ent2}
              overrideStrings={{
                create: createNewEntity,
                search: searchNewEntity,
              }}
              hasSelectAll={false}
              disabled={entitylevel1 === "" || disableAll}
              isCreatable={creatableEntity2}
              reset={resetOptions}
            ></MultiSelectCreatableOption>
          </div>
          <div className="extend-row-input">
            <span>
              {ent3}
              <span className="required-star">*</span>
            </span>
            <MultiSelectCreatableOption
              value={entitylevel3}
              onChange={(e) => {
                handleOnChange(e, "Entity 3");
              }}
              id="base-year-scope-1-2"
              avilableOptions={entity3Options}
              // label={ent3}
              overrideStrings={{
                create: createNewEntity,
                search: searchNewEntity,
              }}
              hasSelectAll={false}
              disabled={entitylevel2 === "" || disableAll}
              isCreatable={creatableEntity3}
              reset={resetOptions}
            ></MultiSelectCreatableOption>
          </div>
          <div className="extend-row-input">
            <span>
              {ent4}
              <span className="required-star">*</span>
            </span>
            <MultiSelectCreatableOption
              value={entitylevel4}
              onChange={(e) => {
                handleOnChange(e, "Entity 4");
              }}
              id="base-year-scope-1-2"
              avilableOptions={entity4Options}
              // label={ent4}
              overrideStrings={{
                create: createNewEntity,
                search: searchNewEntity,
              }}
              hasSelectAll={false}
              disabled={entitylevel3 === "" || disableAll}
              isCreatable={creatableEntity4}
              reset={resetOptions}
            ></MultiSelectCreatableOption>
          </div>
        </div>
      )}
      {showError && (
        <div>
          <span className="extend-modal-error-message">
            {newHierarchyWarningMessage}
          </span>
        </div>
      )}
      {validationErrorMessage && (
        <div>
          <span className="extend-modal-error">
            {validationErrorMessage}
          </span>
        </div>
      )}
      {disableAll && (
        <div>
          <span className="extend-modal-error-message">
            {'Please reset to modify the hierarchy fields.'}
          </span>
        </div>
      )}
      <div className="extend-modal-buttons">
        <Button
          variant="secondary"
          disabled={resetDisable}
          onClick={() => resetFields()}
        >
          {reset}
        </Button>
        <Button
          variant="primary-alt"
          onClick={() => saveValues()}
          disabled={disableApply || disableAll}
        >
          {ApplyBtn}
        </Button>
      </div>
    </div>
  );
}
export function ExtendModal({ isModalOpen, onClose, hierarchy }) {
  return (
    <Modal
      show={isModalOpen}
      onClose={onClose}
      header={
        <div className="emission-filter-modal-header">
          <span>{newTrgtHrchy}</span>
        </div>
      }
      body={
        <ModalBody
          onApply={() => {
            onClose();
          }}
          hierarchy={hierarchy}
        ></ModalBody>
      }
    ></Modal>
  );
}
